// EnrichingLivesSection.js
import React from 'react';
import { Phone } from 'lucide-react';
import enrichingLivesImage from '../assets/enriching-lives-image.jpg';

const EnrichingLivesSection = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Content */}
          <div>
            <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Companion Care
            </p>
            <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              Enriching Lives through Compassionate and Engaging Companion Care
            </h2>

            <div className="space-y-4 text-muted text-base leading-relaxed mb-10">
              <p>
                At Wei Care, we believe companion care goes beyond basic support. It is about building meaningful connections and enriching the lives of the people we support. Our dedicated carers offer compassionate, engaging companionship that supports overall well-being and brings a sense of joy, purpose, and fulfilment.
              </p>

              <p>
                Companion care is designed to address the social and emotional needs of individuals who may be experiencing loneliness, isolation, or a decrease in social interactions. Our carers are more than just companions; they become trusted friends who are there to listen, offer support, and engage in meaningful conversations. They provide a comforting presence, creating a sense of belonging and reducing feelings of isolation.
              </p>
            </div>

            <a
              href="tel:+61480804640"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
            >
              <Phone size={18} />
              Call +61 420 162 243
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={enrichingLivesImage}
              alt="A young carer embracing an older man"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnrichingLivesSection;
